import lemonMalicious from '@/assets/img/lemon-malicious.svg';
import starIcon from '@/assets/icons/star.svg';
import shieldIcon from '@/assets/icons/shield.svg';
import filterIcon from '@/assets/icons/filter.svg';
import './WhyChooseLemon.scss';

const FEATURES = [
  {
    icon: starIcon,
    title: 'Service 100% gratuit',
    description:
      'Lemon vous recommande les meilleures offres disponibles actuellement pour économiser sur ses abonnements.',
  },
  {
    icon: shieldIcon,
    title: 'On ne sait rien sur vous',
    description:
      'Et on s\'en fiche ! Pas de numéro de tel, d\'adresse ou de pièce d\'identité pour utiliser Lemon.',
  },
  {
    icon: filterIcon,
    title: 'Prix des forfaits mis à jour quotidiennement',
    description:
      'Prix et offres mis à jour quotidiennement par nos équipes expertes.',
  },
] as const;

export function WhyChooseLemon() {
  return (
    <section className="why-choose-lemon">
      <div className="why-choose-lemon__header">
        <img src={lemonMalicious} alt="" className="why-choose-lemon__mascot" width={96} height={154} />
        <h2 className="why-choose-lemon__title">
          Pourquoi choisir Lemon.fr pour comparer vos abonnements ?
        </h2>
      </div>
      <div className="why-choose-lemon__grid">
        {FEATURES.map((feature) => (
          <div key={feature.title} className="why-choose-lemon__card">
            <span className="why-choose-lemon__icon">
              <img src={feature.icon} alt="" width={24} height={24} />
            </span>
            <div className="why-choose-lemon__card-container">
              <h3 className="why-choose-lemon__card-title">{feature.title}</h3>
              <p className="why-choose-lemon__card-text">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
